import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  display: table;
  margin: 36px auto;
`;

export const PaginationContainer = styled.ul`
  display: flex;
  list-style-type: none;
  width: 100%;
  gap: 8px;
`;

export const DotsWrapper = styled.li`
  color: var(--color-smoke);
  height: 36px;
  width: 36px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
`;

export const PaginationItem = styled.li<any>`
    height: 36px;
    width: 36px;
    text-align: center;
    color: var(--color-smoke);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #C0C2C6;
    border-radius: 4px;
    font-size: 14px;

    &.dots:hover {
      background-color: transparent;
      cursor: default;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
      cursor: pointer;
    }


    ${(p) =>
      p.selected &&
      `
        pointer-events: none
        color: var(--color-tangerine);
        border: 1px solid #F4534A;

        &:hover {
          background-color: transparent;
          cursor: default;
        }
    `}

    ${(p) =>
      p.disabled &&
      `
        pointer-events: none
        color: #C0C2C6;

        &:hover {
          background-color: transparent;
          cursor: default;
        }
    `}

    .arrow {
      &::before {
        position: relative;
        content: '';
        display: inline-block;
        width: 0.4em;
        height: 0.4em;
        border-right: 0.12em solid rgba(0, 0, 0, 0.87);
        border-top: 0.12em solid rgba(0, 0, 0, 0.87);
      }

      &.left {
        transform: rotate(-135deg) translate(-50%);
      }

      &.right {
        transform: rotate(45deg);
      }
    }
  }
`;
